import React from 'react';
import { motion } from 'framer-motion';
import useReveal from '../../utils/useReveal';
import styled from 'styled-components';
import { Bio } from '../../data/constants';
import { sectionShell, sectionTitle } from '../../styles/sectionStyles';
const Section = styled.section`${sectionShell}`;
const Layout = styled.div`
 width: 100%; max-width: 1180px; display: grid; grid-template-columns: 0.8fr 1.2fr; gap: 80px; align-items: center;
 @media(max-width: 900px) { gap: 36px; grid-template-columns: 1fr; }
`;
const Portrait = styled.img`
 display: block; width: 100%; height: auto; max-width: 430px; aspect-ratio: 4 / 5; object-fit: cover; object-position: center 35%; border-radius: 20px;
 @media(max-width: 900px) { max-width: 380px; }
`;
const Copy = styled.div`
 min-width: 0; h2 { ${sectionTitle} } p { margin-top: 24px; color: var(--muted); font-size: 17px; line-height: 1.85; }
`;
const Eyebrow = styled.span`display: block; margin-bottom: 16px; color: var(--accent); font-size: 12px; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase;`;
const Focus = styled.div`
 display: flex; flex-wrap: wrap; gap: 10px; margin-top: 28px;
 span { padding: 9px 12px; border: 1px solid var(--border); border-radius: 8px; color: var(--text); font-size: 13px; }
`;
export default function About() {
 const reveal = useReveal();
 return <Section id="about"><Layout>
 <Portrait as={motion.img} {...reveal} src={`${process.env.PUBLIC_URL || '.'}/IMG_6453.jpg`} alt="Kisho Jeyapragash in formal attire" width={2080} height={3120} loading="lazy" decoding="async" />
 <Copy as={motion.div} {...reveal} transition={{ ...reveal.transition, delay: reveal.transition.duration ? 0.08 : 0 }}><Eyebrow>About me</Eyebrow><h2>The engineer behind the work.</h2><p>{Bio.description}</p>
 <Focus>{['Backend Development', 'Full-Stack Engineering', 'Database Design', 'AI Integration'].map(item => <span key={item}>{item}</span>)}</Focus></Copy>
 </Layout></Section>;
}
